import { render, staticRenderFns } from "./order-filters.vue?vue&type=template&id=ddddaa0e&lang=pug&"
import script from "./order-filters.vue?vue&type=script&lang=js&"
export * from "./order-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports